import { z } from 'zod';
// User roles
export const UserRoleSchema = z.enum(['Admin', 'LicenceManager', 'Viewer']);
// Editable fields by role
export const EditableFieldsSchema = z.object({
    Admin: z.array(z.string()).default([
        'customer_key',
        'current_account_count',
        'licence_type',
        'status',
        'valid_through',
        'purchaser_aws_account_id',
        'hub_aws_account_id',
        'customer_details',
        'registration_email',
        'last_updated',
        'max_accounts',
        'product_code',
        'session_token',
        'session_expiry',
        'entitlements',
        'version',
        'customer_identifier',
    ]),
    LicenceManager: z.array(z.string()).default([
        'status',
        'valid_through',
        'licence_type',
        'max_accounts',
    ]),
    Viewer: z.array(z.string()).default([]),
});
// Helper function to get editable fields for a role
export const getEditableFields = (role) => {
    const fields = EditableFieldsSchema.parse({});
    return fields[role];
};
// Helper function to check if a field is editable for a role
export const isFieldEditable = (role, field) => {
    const editableFields = getEditableFields(role);
    return editableFields.includes(field);
};
//# sourceMappingURL=permissions.schema.js.map